import { render } from "./StoreTransfer.vue?vue&type=template&id=1f6f8174&scoped=true"
import script from "./StoreTransfer.vue?vue&type=script&lang=js"
export * from "./StoreTransfer.vue?vue&type=script&lang=js"

import "./StoreTransfer.vue?vue&type=style&index=0&id=1f6f8174&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f6f8174"]])

export default __exports__